import { Checkbox } from 'components/Checkbox/Checkbox'
import { mapApiEmitterTypeToLabel } from 'utils/mapApiEmitterTypeToLabel'
import type { TEmitterVisibilityTogglesProps } from './types'

export const EmitterVisibilityToggles = ({
  emitterTypes,
  visibleEmitters,
  onToggle,
}: TEmitterVisibilityTogglesProps) => (
  <div css={{ display: 'flex', flexWrap: 'wrap', gap: 16 }}>
    {emitterTypes.map((emitterType) => (
      <label
        key={emitterType}
        css={{
          alignItems: 'center',
          cursor: 'pointer',
          display: 'flex',
          fontSize: 14,
          gap: 8,
        }}
      >
        <Checkbox
          checked={visibleEmitters[emitterType] || false}
          onChange={() => onToggle(emitterType)}
          css={{ cursor: 'pointer' }}
        />
        <span>{mapApiEmitterTypeToLabel(emitterType)}</span>
      </label>
    ))}
  </div>
)
